angular.module('shbdeployer.integrations.storidge').controller('StoridgeDriveController', [
  '$scope',
  '$state',
  '$transition$',
  'Notifications',
  'ModalService',
  'StoridgeDriveService',
  function ($scope, $state, $transition$, Notifications, ModalService, StoridgeDriveService) {
    $scope.actionInProgress = false;

    $scope.removeDrive = function () {
      ModalService.confirm({
        title: 'Вы уверены?',
        message: 'Исключить этот диск из пула хранения?',
        buttons: {
          confirm: {
            label: 'Удалить',
            className: 'btn-danger',
          },
        },
        callback: function onConfirm(confirmed) {
          if (!confirmed) {
            return;
          }
          $scope.actionInProgress = true;
          StoridgeDriveService.remove($scope.drive.Id)
            .then(function () {
              Notifications.success('Готово', 'Диск исключен из пула хранения');
              $state.go('storidge.drives', {}, { reload: true });
            })
            .catch(function error(err) {
              Notifications.error('Ошибка', err, 'Не удалось исключить диск из пула хранения');
            })
            .finally(function final() {
              $scope.actionInProgress = false;
            });
        },
      });
    };

    function initView() {
      $scope.id = $transition$.params().id;

      StoridgeDriveService.drive($scope.id)
        .then(function success(data) {
          $scope.drive = data;
        })
        .catch(function error(err) {
          Notifications.error('Ошибка', err, 'Не удалось получить сведения о диске');
        });
    }

    initView();
  },
]);
